//电压值标签
export function myMultiRectangle(ctx, node) {
  var wr = node.borderRadius;
  var hr = node.borderRadius;

  if (node.borderRadius < 1) {
    wr = node.rect.width * node.borderRadius;
    hr = node.rect.height * node.borderRadius;
  }

  var r = wr < hr ? wr : hr;

  if (node.rect.width < 2 * r) {
    r = node.rect.width / 2;
  }

  if (node.rect.height < 2 * r) {
    r = node.rect.height / 2;
  }

  ctx.beginPath();
  if(node.data){
    var rows=node.data.length;
    var offset=5;
    var rowheight=(node.rect.height-(rows-1)*offset)/rows;
    var yvalue=node.rect.y;
    let orginFillStyle=ctx.fillStyle;
    for(var i=0;i<rows;i++){
      var customdata=node.data[i];
      ctx.moveTo(node.rect.x + r, yvalue);
      ctx.arcTo(node.rect.x + node.rect.width, yvalue, node.rect.x + node.rect.width, yvalue + rowheight, r);
      ctx.arcTo(node.rect.x + node.rect.width, yvalue + rowheight, node.rect.x, yvalue + rowheight, r);
      ctx.arcTo(node.rect.x, yvalue + rowheight, node.rect.x, yvalue, r);
      ctx.arcTo(node.rect.x, yvalue, node.rect.x + node.rect.width, yvalue, r);
      ctx.closePath();
      if(customdata.preText){
        let preTextData=customdata.preText;
        if(preTextData.fontSize){
          ctx.font = (node.fontStyle || 'normal') + " normal " + (node.fontWeight || 'normal') + " " + preTextData.fontSize + "px/" + node.lineHeight + " " + node.fontFamily;
        }
        if (preTextData.fontColor) {
          ctx.fillStyle = preTextData.fontColor;
        } 
        let metrics = ctx.measureText(preTextData.text);
        ctx.fillText(preTextData.text,node.rect.x-Math.floor(metrics.width)-5,yvalue+rowheight/2);
      }
      if(customdata.endText){
        let endTextData=customdata.endText;
        if(endTextData.fontSize){
          ctx.font = (node.fontStyle || 'normal') + " normal " + (node.fontWeight || 'normal') + " " + endTextData.fontSize + "px/" + node.lineHeight + " " + node.fontFamily;
        }
        if (endTextData.fontColor) {
          ctx.fillStyle = endTextData.fontColor;
        } 
        ctx.fillText(endTextData.text,node.rect.x+node.rect.width+5,yvalue+rowheight/2);
      }
      if(customdata.midText){
        let midTextData=customdata.midText;
        if(midTextData.fontSize){
          ctx.font = (node.fontStyle || 'normal') + " normal " + (node.fontWeight || 'normal') + " " + midTextData.fontSize + "px/" + node.lineHeight + " " + node.fontFamily;
        }
        if (midTextData.fontColor) {
          ctx.fillStyle = midTextData.fontColor;
        } 
        let metrics = ctx.measureText(midTextData.text);
        let xoffset=(node.rect.width-Math.floor(metrics.width))/2
        ctx.fillText(midTextData.text,node.rect.x+xoffset,yvalue+rowheight/2);
      }
      yvalue=yvalue+rowheight+offset;
    }
    ctx.fillStyle=orginFillStyle;
  }
  
  
  
  (node.fillStyle || node.bkType) && ctx.fill();
  ctx.stroke();
}